<script setup lang="ts">
import { computed } from 'vue'
import type { Folder } from '../types'
import { childFolders } from '../utils/folderCounts'
import FolderTreeNode from './FolderTreeNode.vue'
const props = defineProps<{ folders: Folder[]; active: string; expanded: Set<string> }>()
const emit = defineEmits<{ select: [string]; toggle: [string] }>()
const roots = computed(() => childFolders(props.folders, 'root'))
</script>
<template>
  <div class="tree-node" :class="{ active: active === 'root', open: expanded.has('root') }" @click="emit('select', 'root')"><span class="tree-toggle" :class="{ leaf: !roots.length }" @click.stop="emit('toggle', 'root')"></span><span class="tree-folder-tab"></span><span class="tree-label">/</span></div>
  <template v-if="expanded.has('root')"><FolderTreeNode v-for="folder in roots" :key="folder.id" :folder="folder" :folders="folders" :active="active" :expanded="expanded" :depth="1" @select="emit('select', $event)" @toggle="emit('toggle', $event)" /></template>
</template>
